export default {"src":"/_next/static/media/profile-placeholder.47777fd6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};